module.exports = __webpack_public_path__ + "static/leader2-4b65c376592ca3964614ce34b11833e3.png";